import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FormsService } from '../../services/forms';

@Component({
    selector: 'forms',
    templateUrl: 'forms.html',
    styleUrls: ['forms.css']
})

export class Forms {

    personId:number;
    results: any[] = [];

    constructor(private forms: FormsService,
        private route: ActivatedRoute,
        private router: Router,) { }

    ngOnInit() {
        this.forms.collection$.subscribe((data: any[]) =>this.results=data);
        this.route.params.subscribe(params => {
            const id: number = +params['id'];
            console.log('FORMS', id);
            this.personId = id;
            this.forms.getForms(this.personId);
        });
        
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms.ts